<template>
  <b-card>
    {{ $store.getters['question/optionsCategory'] }}
    <FormView
      :data="$store.getters['question/detailData']"
      :fields="$store.getters['question/tableFields']"
      @load="loadData"
    />
  </b-card>
</template>

<script>
import FormView from '@/layouts/components/FormView.vue'

import {
  BCard,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    FormView,
  },
  mounted() {
    this.getAllFavorite()
  },
  methods: {
    loadData(id) {
      return this.$store.dispatch('question/getDetail', id)
    },
    getAllFavorite() {
      return this.$store.dispatch('question/getOptionsCategory')
    },
  },
}
</script>

<style scoped>

</style>
